<template>
  <div class="ml-5 mr-5">
    <div class="text-center">
      <loading
        :active.sync="isLoaderVisible"
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="true"
      ></loading>
    </div>

    <div class="text-left">
      <v-container fluid>
        <v-row class="no-gutters">
          <v-col class="d-flex align-center justify-end"  style="flex-wrap: wrap;">
            <v-btn
              color="primary"
              class="mr-0"
              small
              v-show="checkIfOperationExistForModule('delete')"
              :disabled="selectedItems.length===0"
              @click="handleDeleteRecords"
            >
              Delete
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="tableWrapper">
              <v-data-table
                :loading="isLoading"
                :headers="headers"
                :items="items"
                :page.sync="page"
                :options.sync="options"
                :server-items-length="totRecords"
                @page-count="pageCount = $event"
                v-model="selectedItems"
                hide-default-footer
                show-select
                item-key="suggestion_id"
                class="elevation-1"
              >
                <template v-slot:item.email="{ item }">
                  <a
                    :href="`mailto:${item.email}`"
                    class="text-decoration-none"
                  >
                    {{ item.email }}
                  </a>
                </template>
                <template v-slot:item.suggestion="{ item }">
                  <div class="suggestion-text">
                    {{ item.suggestion }}
                  </div>
                </template>
              </v-data-table>

              <div class="text-center pt-4 pb-4">
                <Pagination
                  :isloading="isLoading"
                  :startRecord="startRecord"
                  :currentPage="currentPage"
                  :lastPage="lastPage"
                  :lastRecord="lastRecord"
                  :totRecords="totRecords"
                  :isCurrentPageClass="isCurrentPageClass"
                  :perpage="perpage"
                  :getLastPageClass="getLastPageClass"
                  :totPage="totPage"
                  :getPages="getPages"
                  @handlePerPage="handlePerPage"
                  @paginate="paginate"
                  @last="last"
                  @getDataByPage="getDataByPage"
                  :showPerPage="true"
                />
              </div>
            </div> 
          </v-col>
        </v-row>
      </v-container>
    </div>

  </div>
</template>
<script>

import Loading from "vue-loading-overlay";
import Pagination from "./component/Pagination.vue";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { Loading, Pagination },
  data() {
    return {
      items: [],
      selectedItems: [],
      options: {},
      isLoading: false,
      page: 1,
      pageCount: 0,
      perpage: 10,
      totRecords: 0,
      emailSearchQuery: '',
      sortDesc: true,
      sortBy: "emailAddress",

      isMemberFormLoading: false,
      isDeletingRecords: false,
     
      headers: [
        {
          text: "Name",
          value: "name",
          sortable: false,
          width: "140",
          class: "v-data-table-header",
        },
        {
          text: "Email",
          value: "email",
          sortable: false,
          width: "140",
          class: "v-data-table-header",
        },
        {
          text: "Phone",
          value: "phone",
          sortable: false,
          width: "140",
          class: "v-data-table-header",
        },
        {
          text: "Message",
          value: "suggestion",
          sortable: false,
          width: "160",
          class: "v-data-table-header",
        },
        {
          text: "Send Date",
          value: "sendDate",
          sortable: false,
          width: "120",
          class: "v-data-table-header",
        },
      ],
    };
  },
  computed: {
    isLoaderVisible() {
      return this.isLoading || this.isDeletingRecords
    },
    usersPayload(){
      return {
        page_number: this.page,
        page_size: this.perpage,
        emailAddress: this.emailSearchQuery,
      }
    },
    //pagination computed methods
    startRecord: function () {
      return parseInt(this.lastRecord) - parseInt(this.perpage) + parseInt(1);
    },
    lastRecord: function () {
      return this.perpage * this.currentPage;
    },
    isCurrentPageClass: function () {
      return this.currentPage === 1 ? "" : "notactivespan";
    },
    getLastPageClass: function () {
      return parseInt(this.lastPage) === parseInt(this.currentPage)
        ? ""
        : "notactivespan";
    },
    totPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
    getPages: function () {
      return this.$utils.getPages(
        this.lastPage,
        this.currentPage,
        this.totPage
      );
    },
    currentPage: function () {
      return this.page;
    },
    lastPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
    endIndex: function () {
      return this.perpage * this.page;
    },
    startIndex: function () {
      if (this.page == 1) {
        return this.perpage * 0;
      } else {
        return this.endIndex - this.perpage;
      }
    },
  },
  watch: {
    usersPayload(){
      this.fetchData();
    },
  },
  methods: {
    //pagination methods
    getDataByPage(value) {
      this.page = value;
    },
    handlePerPage(value) {
      if(this.perpage===value){
        return;
      }
      this.perpage = value;
      this.page = 1;
    },
    paginate(n) {
      if(n==0){
        // First page
        this.page = 1
      }else{
        const nextPage = this.page + n;
        this.page = Math.min(Math.max(1, nextPage), this.pageCount)
      }
    },
    last() {
      this.page = this.lastPage;
    },

  async fetchData() {
    this.isLoading = true;
    try {
      const suggestionMailUrl = this.$url("SUGGESTION_MAIL");
      const response = await this.$fetch({ requiresAuth: true, operation: "view", vueScope: this })
        .get(suggestionMailUrl,  { params: { page_number: this.page, page_size: this.perpage } })
      this.items = response.data?.payload?.suggestion_mail_data || [];
      this.items = response.data?.payload?.suggestion_mail_data?.map(item=>({
        ...item,
        sendDate: item?.inserted_date?.split(" ")[0]??''
      }));
      this.totRecords = response.data?.payload?.count || 0;
      this.pageCount = response.data?.payload?.total_pages || 0;
    } catch (error) {
      console.error(error);
      this.$swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong!",
      });
    } finally {
      this.isLoading = false;
    }
  },

  async handleDeleteRecords(){
    this.$swal
      .fire({
        title: "Are you sure?",
        text: "This will delete these records",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: false,
        closeOnCancel: false,
      })
      .then(async (result) => {
        if(!result.isConfirmed || !this.selectedItems?.length){
          return;
        }
        this.isDeletingRecords = true;
        let data = {
          suggestion_id: this.selectedItems.map((item)=>item.suggestion_id)
        };
        try {
          const suggestionMailUrl = this.$url("SUGGESTION_MAIL");
          const response = await this.$fetch({
            requiresAuth: true,
            operation: "delete",
            vueScope: this,
          }).delete(suggestionMailUrl, { data });
          if (response.data?.status == 'success') {
            this.$swal.fire({
              icon: "success",
              title: "Selected record(s) has been deleted",
              text: response.data?.message,
            });
            this.fetchData();
            this.selectedItems=[]
          }else{
            throw new Error('Something went wrong')
          }
        } catch (error) {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
          });
        } finally {
          this.isDeletingRecords = false;
        }
      });
  },
    checkIfOperationExistForModule(type) {
      return this.$utils.checkIfOperationExistForModule(this, type);
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
<style scoped>
.suggestion-text {
  white-space: pre-wrap !important;   /* preserves line breaks */
  word-break: break-word !important;  /* prevents overflow */
}

</style>